import { assets, colors } from "@util/constants";
import { Container, GiveMeSomeSpace } from "@util/standard";
import React from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

const StyledCopyButton = styled.div`
  width: 38.5px;
  height: 38.5px;
  border: 1px solid var(--theme-primary-color);
  border-radius: 19.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &hover {
    background-color: var(--theme-primary-color);
  }
`;

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  PinterestShareButton,
  PinterestIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import { IconButton } from "@global";

interface Props {
  title?: string;
  url: string;
  image?: any;
}

const SocialShare = (props: Props) => {
  const { url, image } = props;

  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    toast.success("Copied to clipboard");
  };

  return (
    <Container>
      <FacebookShareButton url={url}>
        <FacebookIcon size={40} round={true} />
      </FacebookShareButton>
      <GiveMeSomeSpace />

      <FacebookMessengerShareButton url={url}>
        <FacebookMessengerIcon size={40} round={true} />
      </FacebookMessengerShareButton>

      <GiveMeSomeSpace />

      <PinterestShareButton url={url} media={image}>
        <PinterestIcon size={40} round={true} />
      </PinterestShareButton>
      <GiveMeSomeSpace />

      <WhatsappShareButton url={url}>
        <WhatsappIcon size={40} round={true} />
      </WhatsappShareButton>

      <GiveMeSomeSpace />

      <TwitterShareButton url={url}>
        <TwitterIcon size={40} round={true} />
      </TwitterShareButton>

      <GiveMeSomeSpace />
      <StyledCopyButton onClick={handleCopy}>
        <img
          src={assets.close}
          alt={"Copy to clipboard"}
          width="22px"
          height="22px"
        />
      </StyledCopyButton>
    </Container>
  );
};

export default SocialShare;
